import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { isApiError } from '@/lib/api/errors'
import { sessionBus } from '@/lib/api/session'

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: { /** Let the caller handle 401 (the session probe and sign-in itself). */ ownsAuthErrors?: boolean }
    mutationMeta: { ownsAuthErrors?: boolean }
  }
}

function onGlobalError(error: unknown, meta: { ownsAuthErrors?: boolean } | undefined): void {
  if (!isApiError(error) || meta?.ownsAuthErrors) return
  if (error.status === 401) sessionBus.ended('expired')
}

/** Query defaults from 03-frontend §5.2: SSE keeps data fresh, so no focus refetch and no polling. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: (error, query) => onGlobalError(error, query.meta) }),
    mutationCache: new MutationCache({
      onError: (error, _vars, _ctx, mutation) => onGlobalError(error, mutation.meta),
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failures, error) => isApiError(error) && error.status >= 500 && failures < 2,
      },
      mutations: { retry: false },
    },
  })
}
